module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/notokr-light.woff2
// module id = F1gI
// module chunks = 0